
    var riot = require('riot')
    //src: starling/src/tags/creation-tools.html
riot.tag2('creation-tools',
  '<ul ref="creationToolsList" class="creation-tools_list"> <li class="creation-tools_list_item tip-container" draggable="true" data-component-id="basic-card"> <button class="creation-tool"> <svg class="creation-tool_icon icon" height="17"> <use xlink:href="#card-icon"></use> </svg> </button> <tip class="creation-tool_tip creation-tool_tip--align-top tip-align-true-right"> <h3 class="creation-tool_tip_title">Basic card</h3> <p class="creation-tool_tip_description">A card is the basic unit. It can represent anything -- a person, place, object, or any idea at all</p> </tip> </li> <li class="creation-tools_list_item tip-container" draggable="true" data-component-id="list-card"> <button class="creation-tool"> <svg class="creation-tool_icon icon"> <use xlink:href="#list-card-icon"></use> </svg> </button> <tip class="creation-tool_tip tip-align-true-right"> <h3 class="creation-tool_tip_title">List card</h3> <p class="creation-tool_tip_description">A card with some items in a list</p> </tip> </li> <li class="creation-tools_list_item tip-container" draggable="true" data-component-id="region"> <button class="creation-tool"> <svg class="creation-tool_icon icon" height="24"> <use xlink:href="#region-icon"></use> </svg> </button> <tip class="creation-tool_tip tip-align-true-right"> <h3 class="creation-tool_tip_title">Region</h3> <p class="creation-tool_tip_description">Use regions to identify sections of the canvas</p> </tip> </li> <li class="creation-tools_list_item tip-container creation-tools_list_item--relationship-tool" draggable="true" data-component-id="relationship-tool"> <button class="creation-tool"> <svg class="creation-tool_icon icon" height="36"> <use xlink:href="#relationship-icon"></use> </svg> </button> <tip class="creation-tool_tip tip-align-true-right"> <h3 class="creation-tool_tip_title">Relationship</h3> <p class="creation-tool_tip_description">Drag the endpoints of the relationship tool to attach it to two cards and relate them</p> </tip> </li> <li if="{!parent.isOpen || !parent.isTabActive(\'creation-tools-tab\')}" ref="moreToolsButton" class="creation-tools_list_item creation-tools_list_item--divider creation-tools_more-tools-button {parent.isTabActive(\'creation-tools-tab\') ? \'creation-tools_list_item--active\' : \'\'} tip-container" onclick="{toggleMoreTools}" data-tip="More tools" data-tip-align="true-right"> <button class="creation-tool"> <i class="creation-tool_icon material-icons">apps</i> </button> </li> <li if="{parent.isOpen && parent.isTabActive(\'creation-tools-tab\')}" class="creation-tools_list_item creation-tools_list_item--divider tools-sidebar_toggler creation-tools_more-tools-button" data-tip="Close sidebar" data-tip-align="true-right" onclick="{toggleMoreTools}"> <button class="creation-tool creation-tool--small"> <svg class="creation-tool_icon icon"> <use xlink:href="#angle-double-left-icon"></use> </svg> </button> </li> </ul>',
  '',
  'ref="creationTools" class="creation-tools {canvas.isViewOnly() ? \'view-only\' : \'\'}" ondragstart="{handleDragStart}" ondragend="{handleDragEnd}" onclick="{handleClick}" onmousemove="{restoreTips}"', function(opts) {
'use strict';

var _this = this;

var canvas = opts.canvas;
canvas.creationToolsTag = this;

this.moreToolsOpen = false;

this.handleClick = this.parent.handleClick.bind(this.parent);
this.handleDragEnd = this.parent.handleDragEnd.bind(this.parent);
this.handleDragStart = this.parent.handleDragStart.bind(this.parent);
this.restoreTips = this.parent.restoreTips.bind(this.parent);

this.hideMoreTools = function () {
  var _refs = _this.refs,
      moreToolsButton = _refs.moreToolsButton,
      moreTools = _refs.moreTools;

  moreToolsButton.classList.remove('creation-tools_list_item--active');
  moreTools.classList.remove('visible');
  _this.moreToolsOpen = false;
};

this.expandMoreTools = function (event) {
  var _refs2 = _this.refs,
      moreToolsButton = _refs2.moreToolsButton,
      moreTools = _refs2.moreTools;

  moreToolsButton.classList.add('creation-tools_list_item--active');
  moreTools.classList.add('visible');
  _this.moreToolsOpen = true;
};

this.toggleMoreTools = function (event) {
  event.stopPropagation();
  canvas.toolsSidebarTag.activateTab({ tabTagName: 'creation-tools-tab' });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('creation-tools')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/creation-tools.html
// module id = 755
// module chunks = 0